import { plugin, debug } from 'light-component';
import { Select } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { t } from '../../i18n';
import { Require } from '../component';
import styles from './style.module.less';
import type { SelectProps } from './types';
import type { ReactElement } from 'react';

interface RenderOption {
  label: string;
  value?: string | number;
  options?: RenderOption[];
}

export function WidgetSelects(props: SelectProps): ReactElement {
  debug.widget('dashboard select', props);

  const { allowClear = true, isTranslate = true } = props;

  if (props.mode === 'thumbnail') {
    return (<ThumbnailSelect />);
  }

  const uniqueValue = new Set<string | number>();
  const options = props.options?.reduce<RenderOption[]>((result, item) => {
    if (item.options != null) {
      result.push({
        label: isTranslate ? t(item.title) : item.title,
        options: item.options.reduce<RenderOption[]>((groupOptions, option) => {
          if (!uniqueValue.has(option.value)) {
            uniqueValue.add(option.value);
            groupOptions.push({
              value: option.value,
              label: isTranslate ? t(option.title) : option.title
            });
          }
          return groupOptions;
        }, [])
      });
      return result;
    }
    if (!uniqueValue.has(item.value)) {
      uniqueValue.add(item.value);
      result.push({
        value: item.value,
        label: isTranslate ? t(item.title) : item.title
      });
    }
    return result;
  }, []);

  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <Select
        className={styles.selectBox}
        disabled={props.readonly}
        title={t(props.title)}
        placeholder={t(props.placeholder ?? '')}
        onChange={value => props.onChange?.(value)}
        value={props.value}
        options={options}
        filterOption={(input, option) => String(option?.label ?? '').toLowerCase().includes(input.trim().toLowerCase())}
        showSearch
        allowClear={allowClear}
        popupMatchSelectWidth={props.popupMatchSelectWidth ?? true}
      />
    </div>
  );
}

function ThumbnailSelect(): ReactElement {
  return (
    <div className={styles.control}>
      <Icons name='AppstoreAddOutlined' className={styles.icon} />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'select', component: WidgetSelects });
